import { api } from '../api';

export const eventsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getSchedules: builder.query({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['ScheduleList']
        }),
        getTherapySchedules: builder.query({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'schedulelist'
                }
            }),
            providesTags: ['TharapistScheduleList']
        }),
        getEventDetails: builder.query({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['EventDetails']
        }),
        getPreferFilter: builder.query({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'preferedlocationstatus'
                }
            }),
            providesTags: ['PreferFilter']
        }),
        createPreferFilter: builder.mutation({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'createdefaultlocorstatus'
                }
            }),
            invalidatesTags: ['PreferFilter']
        }),
        updatePreferFilter: builder.mutation({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'updatedefaultlocorstatus'
                }
            }),
            invalidatesTags: ['PreferFilter']
        }),
        addEventCreate: builder.mutation({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'CREATE'
                }
            }),
            invalidatesTags: ['ScheduleList', 'TharapistScheduleList', 'EventDetails']
        }),
        addEvent: builder.mutation({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: payload.sch_id ? 'UPDATE' : 'CREATE'
                }
            }),
            invalidatesTags: ['ScheduleList', 'TharapistScheduleList', 'EventDetails']
        }),
        updateRecEvent: builder.mutation({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'group_schedule_update'
                }
            }),
            invalidatesTags: ['ScheduleList', 'TharapistScheduleList', 'EventDetails']
        }),

        updateEvent: builder.mutation({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'UPDATE'
                }
            }),
            invalidatesTags: ['ScheduleList', 'TharapistScheduleList', 'EventDetails']
        }),

        deleteEvent: builder.mutation({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DELETE'
                }
            }),
            invalidatesTags: ['EventList', 'ScheduleList', 'TharapistScheduleList']
        }),
        deleteRecEvent: builder.mutation({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'group_schedule_delete'
                }
            }),
            invalidatesTags: ['EventList', 'ScheduleList', 'TharapistScheduleList']
        }),

        deleteAllEvent: builder.mutation({
            query: (payload) => ({
                url: `api/scheduler/schedule/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DELETEAll'
                }
            }),
            invalidatesTags: ['EventList', 'ScheduleList']
        }),
        getPatientSChePreference: builder.query({
            query: (payload) => ({
                url: `api/patient/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'get_preference_by_patient'
                }
            })

        })
    })
});

export const {
    useGetSchedulesQuery,
    useLazyGetSchedulesQuery,
    useGetTherapySchedulesQuery,
    useGetEventDetailsQuery,
    useGetPreferFilterQuery,
    useCreatePreferFilterMutation,
    useUpdatePreferFilterMutation,
    useAddEventMutation,
    useAddEventCreateMutation,
    useUpdateRecEventMutation,

    useUpdateEventMutation,
    useDeleteEventMutation,
    useDeleteRecEventMutation,

    useDeleteAllEventMutation,

    useLazyGetPatientSChePreferenceQuery
} = eventsApi;
